import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-output',
    template: `
   <mat-form-field class="w-full v2-form-field" [formGroup]="form">
        <mat-label *ngIf="to.label">{{ to.label }}</mat-label>
      
       <input
                [required]="to.required"
                type="text"
                matInput
                readonly
                [placeholder]="to.placeholder"
                autocomplete="tel"
                [formControl]="formControl"
            />
        
    </mat-form-field>
  `,
})
export class OutputFieldType extends FieldType<FieldTypeConfig> { }

/*
       <mat-form-field class="w-full v2-form-field" [formGroup]="form">
            <mat-label *ngIf="to.label">{{ to.label }}</mat-label>
            <span class="text-hint" matPrefix *ngIf="to.prefix">{{ to.prefix }}</span>
            <input
                [required]="to.required"
                type="text"
                matInput
                [imask]="imaskConfig"
                [unmask]="true"
                [placeholder]="to.placeholder"
                autocomplete="tel"
                [formControl]="formControl"
            />
            <span class="text-hint" matSuffix *ngIf="to.suffix">{{ to.suffix }}</span>
            <mat-hint *ngIf="to.description">{{ to.description }}</mat-hint>
            <mat-error *ngIf="showError">
                <formly-validation-message [field]="field"></formly-validation-message>
            </mat-error>
        </mat-form-field>

*/